export const phoenix2Endpoints = {
    register: {
        stateAdd: {
            api: '/api/phoenix-v2/register/state',
            method: 'POST',
            parameter: false
        },
        stateEdit: {
            api: '/api/phoenix-v2/register/state/edit',
            method: 'POST',
            parameter: false
        },
        getState: {
            api: '/api/phoenix-v2/register/state',
            method: 'GET',
            parameter: false
        },
        acknowledge: {
            api: '/api/phoenix-v2/register/acknowledge',
            method: 'POST',
            parameter: false
        },
        delegate: {
            api: '/api/phoenix-v2/register/delegate',
            method: 'POST',
            parameter: false
        },
        terms: {
            api: '/api/phoenix-v2/register/terms',
            method: 'POST',
            parameter: false
        },
        getDelegatedState: {
            api: '/api/phoenix-v2/register/delegate/state',
            method: 'GET',
            parameter: false
        },
        delegatedAcknowledge: {
            api: '/api/phoenix-v2/register/delegate/acknowledge',
            method: 'POST',
            parameter: false
        },
        delegatedTerms: {
            api: '/api/phoenix-v2/register/delegate/terms',
            method: 'POST',
            parameter: false
        }
    },
    dictionary: {
        listTemplatesWithSegments: {
            api: '/api/phoenix/v2/template/list-with-segment',
            method: 'GET',
            parameter: false
        },
        configurationListByType: {
            api: '/api/phoenix/v2/configuration/dictionary/',
            method: 'GET',
            parameter: true
        },
        configurationByTypeAndKey: {
            api: '/api/phoenix/v2/configuration/details-by-type-key',
            method: 'GET',
            parameter: true
        }
    },
    configuration: {
        list: {
            api: '/api/phoenix-v2/config',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/phoenix-v2/config/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/phoenix-v2/config/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/phoenix-v2/config/update',
            method: 'POST',
            parameter: false
        }
    },
    contracts: {
        requestCancellation: {
            api: '/api/phoenix-v2/contract/request/cancellation',
            method: 'POST',
            parameter: false
        },
        approveCancellation: {
            api: '/api/phoenix-v2/contract/approve/cancellation',
            method: 'POST',
            parameter: false
        },
        restartProcess: {
            api: '/api/phoenix/order/callback',
            method: 'GET',
            parameter: false
        },
        approve: {
            api: '/api/phoenix-v2/contract/approve',
            method: 'POST',
            parameter: false
        },
        list: {
            api: '/api/phoenix-v2/contract',
            method: 'GET',
            parameter: false
        },
        listSupplier: {
            api: '/api/phoenix-v2/contract/list/supplier',
            method: 'GET',
            parameter: false
        },
        listBuyerSupplier: {
            api: '/api/phoenix-v2/contract/list/buyer/supplier',
            method: 'GET',
            parameter: false
        },
        listApproval: {
            api: '/api/phoenix-v2/contract/list/approval',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/phoenix-v2/contract/details',
            method: 'GET',
            parameter: false
        },
        listByTemplateId: {
            api: '/api/phoenix-v2/contract/list-by-template',
            method: 'GET',
            parameter: false
        },
    },
    preContracts: {
        list: {
            api: '/api/phoenix-v2/pre-contract',
            method: 'GET',
            parameter: false
        },
        listInitiated: {
            api: '/api/phoenix-v2/pre-contract/list/initiated',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/phoenix-v2/pre-contract/details',
            method: 'GET',
            parameter: false
        }
    },
    accreditation: {
        initiate: {
            api: '/api/phoenix-v2/accreditation/initiate',
            method: 'GET',
            parameter: true
        },
        edit: {
            api: '/api/phoenix-v2/accreditation/edit',
            method: 'POST',
            parameter: false
        },
        sign: {
            api: '/api/phoenix-v2/accreditation/sign',
            method: 'POST',
            parameter: false
        }
    },
    renewal: {
        details: {
            api: '/api/phoenix-v2/contract/renew/details',
            method: 'GET',
            parameter: true
        },
        list: {
            api: '/api/phoenix-v2/contract/renew/list',
            method: 'GET',
            parameter: false
        }
    },
    registration: {
        list: {
            api: '/api/phoenix-v2/registration/list',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/phoenix-v2/registration/details',
            method: 'GET',
            parameter: false
        },
        verify: {
            api: '/api/phoenix-v2/registration/verify',
            method: 'GET',
            parameter: false
        },
        cancel: {
            api: '/api/phoenix-v2/registration/cancel',
            method: 'GET',
            parameter: false
        },
        edit: {
            api: '/api/phoenix-v2/registration/edit',
            method: 'POST',
            parameter: false
        },
        createSupplierInvitation: {
            api: '/api/phoenix-v2/registration/supplier/add/',
            method: 'GET',
            parameter: true
        },
        templateInputsSupplierInvitation: {
            api: '/api/phoenix-v2/registration/supplier/inputs-list/',
            method: 'GET',
            parameter: true
        },
        templateInputsSupplierInvitationModify: {
            api: '/api/phoenix-v2/registration/supplier/inputs-modify/',
            method: 'POST',
            parameter: true
        }
    },
    buyerToSeller: {
        termsAndConditions: {
            api: '/api/phoenix-v2/buyer-to-seller/terms-and-conditions',
            method: 'GET',
            parameter: false
        },
        agree: {
            api: '/api/phoenix-v2/buyer-to-seller/terms-and-conditions/agree',
            method: 'POST',
            parameter: true
        },
        notifySignatory: {
            api: '/api/phoenix-v2/buyer-to-seller/notify-signatory',
            method: 'POST',
            parameter: false
        },
        authorizedSignatoryList: {
            api: '/api/phoenix-v2/buyer-to-seller/authorized-signatories/list',
            method: 'GET',
            parameter: false
        },
        getSignedRequests: {
            api: '/api/phoenix-v2/buyer-to-seller/signed-requests/list',
            method: 'GET',
            parameter: false
        },
        authorizedAgree: {
            api: '/api/phoenix-v2/buyer-to-seller/terms-and-conditions/authorized/agree',
            method: 'POST',
            parameter: false
        },
        ongoingRequests: {
            api: '/api/phoenix-v2/buyer-to-seller/ongoingRequests',
            method: 'GET',
            parameter: false
        },
        supplierInvitationContractTemplates: {
            api: '/api/template/list-by-type-and-status',
            method: 'GET',
            parameter: true
        }
    },
    segments: {
        buyerListBySegmentKey: {
            api: '/api/phoenix-v2/contract/buyers/segment',
            method: 'GET',
            parameter: true
        }
    },
    contractTemplate: {
        details: {
            api: '/api/phoenix/v2/template/details/',
            method: 'GET',
            parameter: true
        },
        deleteDraft: {
            api: '/api/phoenix/v2/template/draft/delete/',
            method: 'GET',
            parameter: true
        },
        approveTemplate: {
            api: '/api/phoenix/v2/template/draft/approve/',
            method: 'GET',
            parameter: true
        },
        requestChanges: {
            api: '/api/phoenix/v2/template/draft/request-changes',
            method: 'POST',
            parameter: false
        },
        rejectTemplate: {
            api: '/api/phoenix/v2/template/draft/reject',
            method: 'POST',
            parameter: false
        },
        updatePublished: {
            api: '/api/phoenix/v2/template/edit',
            method: 'POST',
            parameter: true
        },
        listByTypeAndStatus: {
            api: '/api/template/list-by-type-and-status',
            method: 'POST',
            parameter: true
        },
        publishTemplate: {
            api: '/api/phoenix/v2/template/publish-with-approval/',
            method: 'POST',
            parameter: true
        },
        editInitiateTemplate: {
            api: '/api/phoenix/v2/template/edit-initiate',
            method: 'POST',
            parameter: true
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/phoenix2.endpoints.ts